import { Button, Center,Select } from "@mantine/core";
import { modals } from "@mantine/modals";

import SRD_Form from "components/Form";
import React from "react";

import { useNavigate } from "react-router-dom";
import { insertManualInfo } from "../apis/adminManualApis";
import { useRecoilState } from "recoil";
import { userState } from "pages/Login/atom/userState";

function ManualAddForm() {
  const [user, setUser] = useRecoilState(userState);
  const groupId = user.fn_group_id;
  const navigate = useNavigate();

  const usedScopeOptions = [
    { value: "1", label: "전체" },
    { value: "2", label: "그룹 내부" },
  ];

  const SelectUsedScope = (props) => {
    const { field, name, defaultValue } = props;
    return (
      <Select
        label={name}
        data={usedScopeOptions}
        value={field.value}
        defaultValue={defaultValue}
        {...field}
      />
    );
  };

  const fields = [
    {
      key: "title",
      name: "이름",
      type: "text",
    },
    {
      key: "file",
      name: "파일",
      type: "file",
    },
    {
      key: "used_scope",
      name: "공개 범위",
      type: "etc",
      component: SelectUsedScope,
      defaultValue: "1",
    },
  ];

  const onSubmit = (e) => {
    modals.openConfirmModal({
      title: "저장",
      children: <Center>저장 하시겠습니까?</Center>,
   //   centered: true,
      zIndex: 2000,
      labels: { confirm: "저장", cancel: "취소" },
       onConfirm: () => {
         insertManualInfo(e,groupId);
         navigate("/admin/manual");
       },
    });
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Button type="submit">저장</Button>
      </Center>
    );
  };

  return (
    <SRD_Form
      fields={fields}
      onSubmit={onSubmit}
      submitButton={<SubmitButton />}
    />
  );
}

export default ManualAddForm;
